// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"L5-z"};